<template>
  <footer class="layout footer">
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="t-10-px">
            Fottom V.1.0.1 By Soluble Branding 2022. <br>Todos los derechos reservados. 
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GetFooter'
}
</script>
